"use client";

import type { ComponentProps } from "react";
import { Uploader } from "react-vant";
import { toast } from "@/components/global/Toast";
import { uploadImageToServer } from "@/utils/upload";

type ReactVantUploaderProps = ComponentProps<typeof Uploader>;

export type ImageUploaderProps = ReactVantUploaderProps;
const DEFAULT_MAX_FILE_SIZE = 500 * 1024;

const defaultUpload: NonNullable<ReactVantUploaderProps["upload"]> = async (file: File) => {
  try {
    const url = await uploadImageToServer(file);
    return { url };
  } catch (error) {
    const message = error instanceof Error ? error.message : "Upload failed";
    toast.show(message);
    throw error;
  }
};

const defaultBeforeRead: NonNullable<ReactVantUploaderProps["beforeRead"]> = (file) => {
  const currentFile = Array.isArray(file) ? file[0] : file;

  if (currentFile && "size" in currentFile && currentFile.size > DEFAULT_MAX_FILE_SIZE) {
    toast.show("Photo size cannot be over 500kb");
    return false;
  }

  return file;
};

export default function ImageUploader(props: ImageUploaderProps) {
  return (
    <Uploader
      {...props}
      upload={props.upload ?? defaultUpload}
      beforeRead={props.beforeRead ?? defaultBeforeRead}
    />
  );
}
